/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeconferencescardsub3Inputs */



/**
* | output |
* | --- |
* | "Sign up for a conference, complete your registration and see which tasks are still open" |
*
* @param {Homeconferencescardsub3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeconferencescardsub3 = /** @type {((inputs?: Homeconferencescardsub3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeconferencescardsub3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Sign up for a conference, complete your registration and see which tasks are still open")
	return /** @type {LocalizedString} */ ("Bewirb dich für eine Konferenz, vervollständige deine Bewerbung und sieh nach, welche Aufgaben noch zu erledigen sind")
});
export { homeconferencescardsub3 as "homeConferencesCardSub" }